import { ViewEnquiryDto } from "../Models";
import { IDialogService } from "../../common/services/IDialogService";
import { INotificationService } from "../../common/services/INotificationService";
import type { IStateService } from "angular-ui-router";
import { IIndependentLivingService } from "../services/IIndependentLivingService";

class AddToUnitDialogController {
    static $inject = ["independentLiving.service", "notification.service", "$state", "dialog.service", "modalConfig", "$q"];
    public enquiryDto: ViewEnquiryDto;
    public isCorrection: boolean;
    public hasReverseEventPermission: boolean;
    public residencyId: number;
    public latestAdmissionDate: Date;
    public onModalCloseCallback: any;

    constructor(private readonly iluService: IIndependentLivingService,
        private readonly notificationService: INotificationService,
        private readonly $state: IStateService,
        private readonly dialogService: IDialogService,
        private readonly modalConfig: any,
        private readonly $q: any,
    ) {
        this.enquiryDto = modalConfig.enquiry;
        this.isCorrection = modalConfig.isCorrection;
        this.hasReverseEventPermission = modalConfig.hasReverseEventPermission;
        this.residencyId = modalConfig.residencyId;
        this.latestAdmissionDate = modalConfig.latestAdmissionDate;
        this.onModalCloseCallback = modalConfig.onModalCloseCallback;
    }
}
export = AddToUnitDialogController;